'use strict';

module.exports = function take(length) {
  if (length < 0) {
    return new this.constructor(this.items.slice(length));
  }

  return new this.constructor(this.items.slice(0, length));
};


//////////////////
// WEBPACK FOOTER
// ./~/collect.js/dist/methods/take.js
// module id = 1273
// module chunks = 2